import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { AppRoutes } from '@constants/app.route';

export const authRedirectGuard: CanActivateFn = () => {
	const authService = inject(AuthService);
	const router = inject(Router);

	if (authService.isLoggedIn()) {
		// Se l’utente è già autenticato → reindirizza all’home dell’app
		return router.parseUrl(`/${AppRoutes.DATASET}`);
	}

	return true; // altrimenti consenti l’accesso alla pagina /auth
};
